import { FETCH_DATA } from '@state/actions/index.js'

let danceData = {}

const defaultState = {}

const dancesReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FETCH_DATA:
            return fetchData(action.data)

        case 'SET_DANCES':
            return Object.assign({}, state, {
                dances: action.dances,
            })

        case 'SET_DANCE_ON_ADD_PROCESS':
            return Object.assign({}, state, {
                danceOnAddProcess: action.dance,
            })

        case 'SET_SAVE_FROM_RE_AKUM_SEARCH':
            return Object.assign({}, state, {
                saveFromReAkumSearch: action.saveFromReAkumSearch,
            })

        case 'SET_DANCES_STYLES_OPTIONS':
            return Object.assign({}, state, {
                danceStylesOptions: action.styles,
            })

        default:
            return state
    }
}

function fetchData(data) {
    console.log(data)

    danceData = data
    return { ...danceData }
}

export default dancesReducer
